import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { useLazyLoadProjectQuery } from "store/api";
import { useAppDispatch } from "store/hooks";
import { getAppUrl } from "utils/defines";
import { useProject } from "utils/hooks/useProject";
import useTranslation from "utils/hooks/useTranslation";
import {
    //type Profile,
    load as loadProjectAction,
    //goToStep as goToStepProjectAction
} from "store/projectSlice";
import {
    addNotification,
} from "store/componentsSlice";
import Loader from "components/shared/loader";

const LoadProjectPage: React.FC = () => {
    const { t } = useTranslation();
    const { id, uid } = useParams<string>();
    const navigate = useNavigate();
    const { goToStep } = useProject();
    const dispatch = useAppDispatch();
    const [projectService_load] = useLazyLoadProjectQuery();
    

    useEffect(() => {
        async function fetchLoad() {

            try {
                const ProjectData = await projectService_load({ id: id as string, uid: uid }).unwrap();
                dispatch(loadProjectAction(ProjectData))
                const index: any = ProjectData.data?.currentStep;
                goToStep(index);

                dispatch(addNotification({
                    type: 'success',
                    message: t('PROJECT_LOADED'),
                }));

            } catch (e: any) {
                navigate(getAppUrl("/"));
            }
        }

        fetchLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Loader />
        </>
    )
}

export default LoadProjectPage;